import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import { KEY_PREFIX } from "components/streams/hooks/useStreams";
const updateStreamCategories = ({ streamId, categories }) => fetch("PUT", qualifyUrl(`/plugins/org.graylog.plugins.illuminate/stream_categories/${streamId}`), categories);
const useStreamCategoryMutation = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: updateStreamCategories,
    onSuccess: () => {
      UserNotification.success("Stream categories updated successfully.", "Success");
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    },
    onError: (error) => {
      UserNotification.error(`Failed to update stream categories: ${error.message}`);
    }
  });
  return { updateCategories: mutation };
};
export default useStreamCategoryMutation;
